import getEnvironmentVariables from '../../helpers/getEnvironmentVariables'

// Local-dev override: point the app at a local backend/proxy
// (REACT_APP_API_BASE in .env.local). Unset in real builds, where the
// base URL resolves from the hostname as before.
const baseURL =
    process.env.REACT_APP_API_BASE || getEnvironmentVariables().baseURL

export { baseURL }
